import { Component } from '@angular/core';

@Component({
  template: ``,
  styleUrls: [],
  standalone: false,
})
export class ProjectLoadingPageComponent {}
